import type { FC } from "react"
import { twMerge } from "tailwind-merge"

import { calculateQuantityDifference } from "../utils"

import { formatNumber } from "@/utils/number"
import { isNil } from "@/utils/utils"

interface InventoryQuantityDifferenceProps {
  quantity: number | null
  originalQuantity: number
  uomName: string
  showZero?: boolean
  "data-testid"?: string
}

export const InventoryQuantityDifference: FC<InventoryQuantityDifferenceProps> = ({
  quantity,
  originalQuantity,
  uomName,
  showZero,
  "data-testid": testId,
}) => {
  const value = calculateQuantityDifference(quantity, originalQuantity)

  if (isNil(value) || (!value && !showZero)) return null

  return (
    <span
      className={twMerge(value < 0 && "text-secondary-600", value > 0 && "text-tertiary-green-900")}
      data-testid={testId}
    >
      {value > 0 ? "+" : ""}
      {formatNumber(value)} {uomName}
    </span>
  )
}
